import { render, staticRenderFns } from "./TicketList.vue?vue&type=template&id=2237c302&"
import script from "./TicketList.vue?vue&type=script&lang=js&"
export * from "./TicketList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports